import React from 'react';
import { Card } from 'antd';

function SelfRegPendingBlock() {
  return (
    <div className="self-reg-pending-wrap">
      <div className="self-reg-pending-container">
        <Card className="gx-card self-reg-pending-card">
          <div className="self-reg-pending-card__title">Договор ожидает подписания</div>
          <div className="self-reg-pending-card__description">
            Мы с вами свяжемся в ближайшее время, больше информации доступно по телефону{' '}
            <a href="tel:+74951210799" className="self-reg-pending-card__phone">+7 (495) 121-07-99</a>
          </div>
        </Card>
      </div>
    </div>
  );
}

export default SelfRegPendingBlock;
